// BrandLogos: sezione loghi marchi partner
export default function BrandLogos() {
  const brands = [
    { src: '/ottica-bellodi-centro-ottico-torino-saint-laurent-eyewear.svg', alt: 'Saint Laurent Eyewear - Ottica Bellodi Torino' },
    { src: '/ottica-bellodi-centro-ottico-torino-lacoste-eyewear.svg', alt: 'Lacoste Eyewear - Ottica Bellodi Torino' },
    { src: '/ottica-bellodi-centro-ottico-torino-etro-milano.svg', alt: 'Etro Milano - Ottica Bellodi Torino' },
    { src: '/ottica-bellodi-centro-ottico-torino-beckham-eyewear.svg', alt: 'David Beckham Eyewear - Ottica Bellodi Torino' },
    { src: '/ottica-bellodi-centro-ottico-torino-etnia-barcelona.svg', alt: 'Etnia Barcelona - Ottica Bellodi Torino' },
    { src: '/ottica-bellodi-centro-ottico-torino-liu-jo-eyewear.svg', alt: 'Liu Jo Eyewear - Ottica Bellodi Torino' },
  ];

  return (
    <div className="flex flex-wrap justify-center items-center gap-10 md:gap-16">
      {brands.map((brand) => (
        <div key={brand.alt} className="flex items-center justify-center">
          <img
            src={brand.src}
            alt={brand.alt}
            width="160"
            height="80"
            className="h-16 md:h-20 w-auto object-contain transition-transform duration-300 hover:scale-105"
            loading="lazy"
          />
        </div>
      ))}
    </div>
  );
}
